<template>
  <div class="feedback-component screen">
    <div class="header-band">
      <AdminModalMenu @close="beforeClose()" />
      <div class="title-group">
        <span class="title">Contact Netstar</span>
        <div class="divider"></div>
        <span class="subtitle">Feedback</span>
      </div>
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <Alert />
    <div class="panel">
      <form ref="form" @submit.prevent>
        <div class="form-group">
          <label for="assistanceType">Assistance type:</label>
          <v-select class="custom-select form-control" id="assistanceType" v-model="model.assistanceType" :options="['Report a bug', 'Feedback']" required />
        </div>
        <div class="form-group">
          <label for="message">Message:</label>
          <textarea class="form-control" id="message" rows="5" v-model="model.message" required />
        </div>
      </form>
    </div>
    <div class="buttons">
      <StatusIndicator class="mr-3" :success="submitSuccess" :error="submitError" />
      <button class="btn btn-outline" @click="submit()">
        <span v-show="!processing">Submit</span>
        <Spinner v-show="processing" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.feedback-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    height: 54px;
    padding: 0 30px;
    margin: -20px -30px 25px -30px;
    color: #fff;
    position: relative;
    font-size: 1.1875rem;

    /deep/ .menu-button .icon {
      fill: #fff;
    }

    .title-group {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .title {
      font-weight: 600;
      color: #fff;
      margin-left: 5px;
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;

      &.divider-wide {
        margin: 0 40px 0 15px;
      }
    }

    .subtitle {
      color: #fff;
    }
  }

  .panel {
    background: $brand-color-4;
    padding: 10px 15px;

    .form-group {
      margin-bottom: 10px;

      .form-control {
        background-color: #fff;
        text-transform: none;
        border: 1px solid $brand-color-2;
      }

      textarea {
        padding: 10px 15px;
      }

      label {
        font-weight: bold;
      }
    }
  }

  .buttons {
    margin-top: 15px;
  }
}

@media (max-width: $md-1) {
  .feedback-component {
    .header-band {
      align-items: flex-start;
      background-color: #fff;
      color: $brand-color-1;
      margin-top: -5px;

      /deep/ .menu-button .icon {
        fill: $brand-color-1;
      }

      .title-group {
        flex-direction: column;
        align-items: flex-start;
      }

      .title {
        font-weight: 600;
        font-size: 19px;
        color: $brand-color-1;
        margin-left: 0;
      }

      .divider {
        display: none;
      }

      .subtitle {
        font-weight: 300;
        font-size: 19px;
        color: $brand-color-1;
      }

      /deep/ .close-button svg path {
        fill: $brand-color-1;
      }
    }
  }
}
</style>

<script>
import { adminService, alertService, modalService } from "@/services";
import StatusIndicator from "@/components/StatusIndicator";
import AdminModalMenu from "@/components/screens/AdminModalMenu";
import CloseButton from "@/components/CloseButton";

export default {
  name: "Feedback",
  components: {
    AdminModalMenu,
    CloseButton,
    StatusIndicator,
  },
  data() {
    return {
      processing: false,
      submitSuccess: false,
      submitError: false,
      model: {},
    };
  },
  computed: {
    isValid() {
      return this.model && this.model.assistanceType && this.model.message;
    },
  },
  created() {
    this.initModelState();
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
    initModelState() {
      this.model = {
        assistanceType: "",
        message: "",
        request: "",
        version: navigator.userAgent,
      };
    },
    submit() {
      if (this.$refs.form.reportValidity()) {
        this.handleSubmit();
      }
    },
    handleSubmit() {
      const { model } = this;

      if (this.isValid) {
        this.processing = true;
        adminService
          .sendFeedback(model)
          .then((result) => {
            this.processing = false;
            if (result) {
              this.initModelState();
              this.submitSuccess = true;
              setTimeout(() => {
                this.submitSuccess = false;
              }, 3000);

              if (this.$isMobile) {
                modalService.showSuccessDialog("Feedback submitted successfully.");
              } else {
                alertService.showSuccessAlert();
              }
            } else {
              alertService.showErrorAlert();
            }
          })
          .catch((error) => {
            this.saving = false;
            this.submitError = true;
            setTimeout(() => {
              this.submitError = false;
            }, 3000);
            if (error.userMessage) {
              alertService.showErrorAlert(error);
            }
          });
      } else {
        alertService.showErrorAlert("Please fill in all fields.");
      }
    },
  },
};
</script>